import { render, staticRenderFns } from "./Mapa.vue?vue&type=template&id=95b07dc0&scoped=true"
import script from "./Mapa.vue?vue&type=script&setup=true&lang=js"
export * from "./Mapa.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Mapa.vue?vue&type=style&index=0&id=95b07dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b07dc0",
  null
  
)

export default component.exports